module.exports = __webpack_public_path__ + "lemon_vue/img/login_bj.cb615c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_bj.png
// module id = VLxK
// module chunks = 1